/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "दोस्ती क्लब",
      "Bumble For Friends ऐप के साथ नये दोस्त खोजें | Bumble",
      "App Store से डाउनलोड करें",
      "इसे Google Play से प्राप्त करें",
      "नये दोस्त बनाने के लिए समर्पित जगह",
      "अपने आस-पास ऐसे लोगों की खोज करें जो असली कनेक्शन के लिए यहां पर हैं।",
      "ज़िंदगी की सभी पड़ावों के लिए दोस्त ढूंढें",
      "शहर में नये हैं? एक नई शुरुआत की जरूरत है? आपका नया दल आपका इंतजार कर रहा है!",
      "सभी के लिए एक सुरक्षित जगह",
      "इंटरनेट के एक ऐसे हिस्से में आपका स्वागत है, जहां आप अपने जैसे हो सकते हैं।",
      "ऐप डाउनलोड करें",
      "असल जीवन में उन लोगों से मिलें जिनकी रुचियां आपके जैसी हैं!",
      "Bumble For Friends पर Plans के साथ लोगों के एक नये ग्रुप को जानें",
      "आपको Plans से जुड़ने के लिए आमंत्रित किया गया है",
      "Plans Bumble For Friends पर एक नया फीचर है जहाँ आप अपने आस-पास के नए दोस्तों के साथ ग्रुप मीटअप बना सकते हैं और उनमें शामिल हो सकते हैं",
      "कुकीज़ प्रबंधित करें",
      "Gender Pay Gap",
      "Modern Slavery Statement",
      "Terms and Conditions",
      "About",
      "Life"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "दिन",
                  "दिनों"
            ],
            "singular": [
                  "दिन",
                  "दिन"
            ]
      },
      "hour": {
            "plural": [
                  "घंटे",
                  "घंटे"
            ],
            "singular": [
                  "घंटे",
                  "घंटे"
            ]
      },
      "minute": {
            "plural": [
                  "मिनट",
                  "मिनटों"
            ],
            "singular": [
                  "मिनट",
                  "मिनट"
            ]
      },
      "month": {
            "plural": [
                  "महीने",
                  "महीनों"
            ],
            "singular": [
                  "महीना",
                  "महीना"
            ]
      },
      "second": {
            "plural": [
                  "सेकंड",
                  "सेकंड"
            ],
            "singular": [
                  "सेकंड",
                  "सेकंड"
            ]
      },
      "year": {
            "plural": [
                  "साल",
                  "सालों"
            ],
            "singular": [
                  "साल",
                  "साल"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
